module.exports = __webpack_public_path__ + "resources/img/career-welfareImg3.f32fd1e5.jpg";